import { useEffect, useState } from 'react';
import { WorkloadTrackingType } from '../../__generated__/graphql';
import { useMyTimeTrackingSettings } from './useMyTimeTrackingSettings';

const SHOW_TRACKED_TIME_STORAGE_KEY = 'projectsShowTrackedTime';

export const useProjectsShowTrackedTime = () => {
  const [showTrackedTime, setShowTrackedTime] = useState(false);
  const [hasLoadedFromStorage, setHasLoadedFromStorage] = useState(false);

  const { data: trackingSettingsData } = useMyTimeTrackingSettings();
  const workloadTrackingType =
    trackingSettingsData?.me.workloads[0]?.flair__Time_Tracking_Type__c;
  const isTimeTrackingWithProjects =
    workloadTrackingType === WorkloadTrackingType.TimeTrackingWithProjects;
  const isOnlyProjectTracking =
    workloadTrackingType === WorkloadTrackingType.ProjectTracking;

  useEffect(() => {
    if (!hasLoadedFromStorage && trackingSettingsData) {
      if (!isTimeTrackingWithProjects) {
        const stored = localStorage.getItem(SHOW_TRACKED_TIME_STORAGE_KEY);
        if (stored === 'true') {
          setShowTrackedTime(true);
        }
      }
      setHasLoadedFromStorage(true);
    }
  }, [trackingSettingsData, isTimeTrackingWithProjects, hasLoadedFromStorage]);

  useEffect(() => {
    if (isTimeTrackingWithProjects) {
      setShowTrackedTime(true);
    }
  }, [isTimeTrackingWithProjects]);

  useEffect(() => {
    if (!isTimeTrackingWithProjects && hasLoadedFromStorage) {
      localStorage.setItem(
        SHOW_TRACKED_TIME_STORAGE_KEY,
        showTrackedTime.toString(),
      );
    }
  }, [showTrackedTime, isTimeTrackingWithProjects, hasLoadedFromStorage]);

  return {
    showTrackedTime,
    setShowTrackedTime,
    isTimeTrackingWithProjects,
    isOnlyProjectTracking,
  };
};
